<footer class="ui inverted very paddedc horizontally fitted segment">
  <div class="ui basic very padded horizontally fitted segment"></div>
  <div class="ui container">
    <div class="ui grid">
      <div
        class="sixteen-wide-mobile eight-wide-tablet four-wide-computer column"
      >
        <img
          class="logo-item"
          src="assets/images/inverted-logo.svg"
          alt="Indianpix"
        />
        <div class="ui basic padded horizontally fitted segment">
          <p>
            At Indian pix we aim at creating fresh & unique experiences by using
            modern technologies alongside creativity, to bridge the gap of user
            experience & user interface.
          </p>
        </div>
      </div>
      <div
        class="sixteen-wide-mobile eight-wide-tablet eight-wide-computer column"
      >
        <h3 class="ui inverted fw-400 center aligned header">Our Office</h3>
        <div class="ui basic padded horizontally fitted segment">
          <img
            src="assets/images/footer-map.svg"
            class="ui centered medium image"
          />
        </div>
      </div>
      <div
        class="sixteen-wide-mobile eight-wide-tablet four-wide-computer column"
      >
        <h3 class="ui inverted fw-400 header">Contact</h3>
        <div class="ui basic padded horizontally fitted segment">
          <p>
            8480 Honeycutt Road, Ste 200, <br />
            #V295 Raleigh, NC 27615
          </p>
          <div class="ui contact-list-item list">
            <a class="item">hello@indianpix.co</a>
            <span class="item">+1 919 864 5327</span>
            <span class="item">+91 980 652 7862</span>
          </div>
        </div>
      </div>
    </div>
    <div class="ui divider"></div>
    <div class="ui middle aligned grid">
      <div
        class="
          sixteen-wide-mobile sixteen-wide-tablet
          three-wide-computer
          column
        "
      >
        <p>© 2021 IndianPix</p>
      </div>
      <div
        class="
          sixteen-wide-mobile sixteen-wide-tablet
          ten-wide-computer
          centered
          aligned
          column
        "
      >
        <div class="ui inverted justify-center text menu">
          <a
            class="item"
            *ngFor="let menuItems of footerMenu"
            href="{{ menuItems.link }}"
          >
            {{ menuItems.manuName }}
          </a>
        </div>
      </div>
      <div
        class="
          sixteen-wide-mobile sixteen-wide-tablet
          three-wide-computer
          column
        "
      >
        <a
          href="https://www.facebook.com/indianpix.agency"
          target="_blank"
          class="ui circular facebook icon button"
        >
          <i class="facebook f icon"></i>
        </a>
        <button class="ui circular twitter icon button">
          <i class="twitter icon"></i>
        </button>
        <a
          href="https://www.linkedin.com/in/indian-pix-13b533209"
          target="_blank"
          class="ui circular linkedin icon button"
        >
          <i class="linkedin in icon"></i>
        </a>
        <a
          href="https://www.instagram.com/official_indianpix/"
          target="_blank"
          class="ui circular instagram icon button"
        >
          <i class="instagram icon"></i>
        </a>
      </div>
    </div>
  </div>
</footer>
